import URL from "@/api/URL";
import fetch from "@/api/fetch";
export function platformData(params) {
  return fetch.post(URL.platformData, params);
}
export function top10Org(params) {
  return fetch.post(URL.top10Org, params);
}
export function callAllLogList(params) {
  return fetch.post(URL.callAllLogList, params);
}
export function queryStatByMonth(params) {
  return fetch.post(URL.queryStatByMonth, params);
}
export function queryTopApiAndModel(params) {
  return fetch.post(URL.queryTopApiAndModel, params);
}
export function getChartDataRedis(params) {
  return fetch.post(URL.getChartDataRedis, params)
}



// WEBPACK FOOTER //
// ./src/api/modules/screen.js